import React from 'react';
import { FormControlLabel, Checkbox as MaterialCheckbox } from '@material-ui/core';

import { CheckboxProps } from './Checkbox.types';

export const Checkbox = (props: CheckboxProps) => {
  return <FormControlLabel control={<MaterialCheckbox {...props} />} label={props.label} />;
};
